<template>
    <div v-if="hasAlert" class="flex-col-center">

        <v-alert v-if="!mobileScreen" type="warning" border="left" class="alert" :icon="false">
            <v-row align="center" >
                <v-col class="flex-row-center-space-between">
                    <div class="flex-row-start">
                        <span class="alert__title"> {{ showingAlert.title }}: </span> 
                        {{ showingAlert.message }}
                    </div>
                    <div v-if="showingAlert.link">
                        <v-btn small outlined class="text-none" route :to="showingAlert.link">
                            {{ showingAlert.action }}
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-alert>

        <v-alert v-if="mobileScreen" type="warning" border="left" class="alert" :icon="false">
            <v-row align="center" > 
                    <div class="alert__title title--mobile"> {{ showingAlert.title }}: </div> 
                    <div class="w-100">
                        {{ showingAlert.message }} 
                    </div>

                <v-col  v-if="showingAlert.link" class="shrink flex-col-end">
                    <v-btn small outlined class="text-none btn--mobile" route :to="showingAlert.link">
                        {{ showingAlert.action }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-alert>

    </div>
</template>

<script>
//Store
import { mapGetters } from "vuex";

//Services
import { getAlertsByCurrentContactIdAndCompanyIdAndResource } from "./service/alert.service";

export default {
    name: 'Alert',
    computed: {
        ...mapGetters('authenticateStore', {
                currentCompany:  'get_currentCompany',
                isLoggedIn: 'isLoggedIn'
            }
        ),
        ...mapGetters('routeStore', {
                actualRoute:  'get_actualRoute'
            }
        )
    },
    data: () => ({
        alertArray: [],
        showingAlert: {},
        alertOffObj:{
            title: 'Sem conexão',
            message: 'Parece que você não está conectado a uma rede de internet!'
        },
        hasAlert: false,
        mobileScreen: false
    }),
    watch: {
        hasAlert() {
            if( this.hasAlert ) this.$emit('hasAlert', true)
        },
        actualRoute() {
            this.verifyIfHasAlerts()
        }
    },
    created() {
        this.verifyIfHasAlerts()
        window.addEventListener("resize", this.compareWidth);

        window.addEventListener('online', () => { //Só vai capturar este evento, caso fique 'offline' pelo menos 1 vez;
            this.verifyIfHasAlerts()
        });

        window.addEventListener('offline', () => {//Captura este evento caso a conexão caia
            if(!this.hasAlert) {
                this.hasAlert = true
                this.showingAlert = this.alertOffObj
                this.alertCounter = -1
            }
            if(this.hasAlert) {
                this.showingAlert = this.alertOffObj
            }
        });
    },
    methods: {
        compareWidth(screenWidth) {
            (screenWidth.target.innerWidth >= 600) ? this.mobileScreen = false : this.mobileScreen = true ;
        },
        verifyIfHasAlerts() {
            if( this.isLoggedIn ) {
                if(navigator.onLine) { //preciso olhar se está online/setar nas outras rotas o alerta de 'offline'
                    getAlertsByCurrentContactIdAndCompanyIdAndResource( this.currentCompany.id, this.actualRoute )
                        .then( success => {
                                if( success.data.length > 0 ) {
                                    this.alertArray = success.data
                                    this.alertCounter = this.alertArray.length -1
                                    this.hasAlert = true
                                    this.transferAlertToShow()

                                } else {
                                    if( this.showingAlert ) {
                                        this.showingAlert = {}
                                        this.hasAlert = false
                                    }
                                }
                            }
                        )
                        .catch( error => {
                                if (error != null) {
                                    this.$toasted.show(error.message, { type: 'error' } )
                                }
                            }
                        )
                }else {
                    if(!this.hasAlert) {
                        this.hasAlert = true
                        this.showingAlert = this.alertOffObj
                        this.alertCounter = -1
                    }else {
                        if(this.showingAlert.title != 'Sem conexão'){
                            this.showingAlert = this.alertOffObj
                        }                         
                    }
                }
            }
        },
        transferAlertToShow() {
            if( this.alertCounter >= 0 ) {
                this.showingAlert = this.alertArray[this.alertCounter]
                this.alertArray.splice(this.alertCounter)
                this.alertCounter--
                this.hasAlert = true

            } else this.hasAlert = false
        }
    }
}
</script>

<style scoped>
.alert {
    max-width: 800px;
    width: 96%;
    margin-bottom: 0px !important;
}
.alert__title {
    font-weight: bold;
    margin-right: 6px;
}
.title--mobile {
    width: 100%;
}
.btn--mobile {
    margin-top: 10px;
}
</style>